import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import V2Contentful from '@Shared/plugins/V2Contentful'

Vue.use(V2Contentful)

/* eslint-disable no-new */
new Vue({
  el: '#home-special-offers-app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./WebResources/vue/default/home/special-offers/main.js